<div class="c-total-amount">
  <div class="c-total-amount__label">{{ label }}:</div>
  <div class="c-total-amount__amount">
    <app-price [amount]="amount"></app-price>
  </div>
</div>
